import { useTranslation } from 'react-i18next';
// import QrCodeScanIcon from '@/assets/images/qr.svg';
import StatWidgetBox from './StatWidgetBox';
import { useDispatch, useSelector } from 'react-redux';
import { setQrCodeModalParams } from '@/features/modals/modalsSlice';
import { selectActiveBuilding } from '@/features/building/buildingSlice';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import QRModal from '@/features/modals/QrCodeModal';

const QrCodeChip = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const activeBuilding = useSelector(selectActiveBuilding);

  const openQrModal = () => dispatch(setQrCodeModalParams({ building: activeBuilding }));
  
  return (
    <>
      <StatWidgetBox
        icon={ <QrCode2OutlinedIcon sx={{ fontSize: 16 }} /> }
        onClick={openQrModal}
        value={'QR'}
      />
      <QRModal />
    </>
  );
};

export default QrCodeChip;
